import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

type Entity = models.FiltroMovimientoCaja;
type Entity2 = models.MovimientoCajaViewDTO;
import { columnas } from "./columns";
import { MovimientoCajaFiltroComponent } from "./filtro";
const resource = resources.MovimientoCaja;

export interface Props {
    value: Entity;
    onChange: (x: Entity) => void;
}

function filtroValido(x: Entity): boolean {
    return true
}

export class MovimientoCajaViewListNoRX extends React.PureComponent<Props> {
    value = (props: Props) => props.value;
    onRegresar = () => history.go('../');
    items2 = createSelectorRx(this.value, filtro => observeResource(resource.queryFiltro, filtro));

    
    valido = createSelectorRx(this.value, filtroValido);

    render() {
        const cols = columnas(this);
        const items = this.items2(this.props);
        const filtro = this.value(this.props);
        
        return (
            <div>
                <kea.Title titulo="Movimiento Caja" onRegresar={this.onRegresar}>
                </kea.Title>
                <MovimientoCajaFiltroComponent value={filtro} onChange={this.props.onChange} ></MovimientoCajaFiltroComponent>
                
                <kea.Grid2 columnas={cols} cookieKey={"MovimientoCajaViewListCookieKey"} items={items} />
            </div>
        )
    }
}

const MovimientoCajaViewListRX = componentToRx(MovimientoCajaViewListNoRX);

export interface State {
    value: Entity;
}

export class MovimientoCajaViewList extends React.PureComponent<{}, State> {
    constructor(props) {
        super(props);
        this.state = {
            value: {
                FechaCreacionInicio: new Date(),
                FechaCreacionFinal: new Date(),
            } as Entity
        };
    }

    value = (state: State) => state.value;
    onChange = (value: Entity) => new Promise<void>(resolve => this.setState({ value: value }, resolve));

    render() {
        const value = this.value(this.state);

        return (
            <MovimientoCajaViewListRX
                value={value}
                onChange={this.onChange}
            />
        )
    }
}


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/movimientoscaja/list/list.tsx